module.exports = __webpack_public_path__ + "img/home_service_team.209fd9b8.png";